import Vue from "vue";
import VueRouter from "vue-router";
import authService from '@/auth.service';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import App from "./App.vue";
import "./axios";

// LightBootstrap plugin
import LightBootstrap from "./light-bootstrap-main";

// Correctly import the allRoutes from routes.js
import routes from "./routes/routes";

import "./registerServiceWorker";
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './registerServiceWorker'




// Plugin setup
Vue.use(VueRouter);
Vue.use(LightBootstrap);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

function getStoredPermissions() {
  try {
    const storedPermissions = localStorage.getItem('PERMISSIONS');
    const parsed = JSON.parse(storedPermissions || '[]');
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    console.warn('Invalid PERMISSIONS in localStorage:', error);
    return [];
  }
}

// Check that permissionsArray and allRoutes are correctly structured
console.log('Permissions Array:', getStoredPermissions());
console.log(routes);

// Configure router
const router = new VueRouter({
  mode: 'history',
  routes,
  linkActiveClass: "nav-item active",
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});

// Router navigation guards
// Router navigation guards
router.beforeEach((to, from, next) => {
  console.log('Navigating from:', from, 'to:', to);

  const publicRouteNames = new Set(['LoginView', 'QuestionsAnswer', 'QuickserveRestaurantMenuView', 'QuickserveRestaurantMembershipView']);

  if (publicRouteNames.has(to.name)) {
    next();
    return;
  }

  // Check if user is logged in
  if (!authService.isLoggedIn()) {
    // Prevent alert from showing when navigating to the LoginView page
    if (!publicRouteNames.has(to.name)) {
      alert('You must be logged in to access this page.');
      next({ name: 'LoginView' });
    } else {
      next();
    }
    return; // Exit navigation guard
  }

  // Ensure permissions are loaded
  const permissionsArray = getStoredPermissions();

  // Extract permission names into a set for quick lookup
  const permissionNames = new Set(
    permissionsArray
      .filter(permission => permission && permission.permission_name)
      .map(permission => permission.permission_name)
  );

  const requiredPermission = to.meta && to.meta.requiredPermission
    ? to.meta.requiredPermission
    : null;

  if (requiredPermission && !permissionNames.has(requiredPermission)) {
    alert('You do not have permission to access this page.');
    next(false);
    return;
  }

  // Check if the route is permitted
  // if (to.name !== 'LoginView' &&
  // to.name !== 'QuestionsAnswer' &&
  // !permissionNames.has(to.path)) {
  //   alert('You do not have permission to access this page.');
  //   next(false); // Prevent navigation
  //   return; // Exit navigation guard
  // }

  // If logged in and permission check passes, proceed with navigation
  next();
});


// Handle session timeout
if (authService.isLoggedIn()) {
  setTimeout(() => {
    localStorage.removeItem('ACCESS_TOKEN');
    window.location.href = "/login";
  }, 14400000); // 4 hours
}

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: (h) => h(App),
  router,
});
